var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"tableTitle":_vm.tableTitle,"pageFooter":true,"InfoHref":_vm.InfoHref,"deleteUrl":'api/emotion/delete',"searchUrl":_vm.url,"statis-href":`AssessStatistics`,"add":false,"report":true,"reportHref":_vm.reportUrl,"form":_vm.form,"tableType":3}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }